import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { FAQS } from "../i18n/translations";
import useSEO from "../hooks/useSEO";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const FAQ = () => {
  const { lang, tr } = useLang();
  const items = FAQS[lang] || FAQS.fr;
  useSEO({
    title: `${tr.faqTitle} — MobiRider`,
    description: tr.hero.subtitle,
    lang,
    jsonLd: { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: items.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
  });
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 md:py-20">
      <h1 className="font-heading font-extrabold text-4xl md:text-5xl text-ink tracking-tight text-center mb-12">{tr.faqTitle}</h1>
      <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`i${i}`} className="bg-white rounded-2xl border border-slate-100 px-6 shadow-sm">
            <AccordionTrigger className="text-lg font-semibold text-ink py-5 hover:no-underline text-left">{f.q}</AccordionTrigger>
            <AccordionContent className="text-lg text-ink-muted leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQ;
